export const scanningConfig = {
    apiPath:
        import.meta.env.VITE_SCANNING_API_ENDPOINT_PATH ||
        (() => {
            throw new Error('VITE_SCANNING_API_ENDPOINT_PATH must be defined');
        })(),
    isDebugMode: import.meta.env.VITE_DEBUG === 'true'
};
